import axios from "axios";
import qs from "qs";
import moment from "moment";
import "moment/min/locales.min";
import "moment-timezone";

moment.locale('ru');

export default class Server
{
    url = 'https://apps.forcs.ru/ajax.php'

    loadProps()
    {
        return new Promise((resolve, reject) => {
            const ajaxParams = {
                action: 'props'
            }

            axios({
                method: "post",
                url: this.url,
                data: qs.stringify(ajaxParams,{ delimiter: '&'})
            }).then(result => {
                if (result.data.error) {
                    alert(result.data.error);
                }
                resolve(result.data);
            }).catch(error => {
                alert('Нет связи с 1С')
            });
        })
    }

    loadCompany(companyXml)
    {
        return new Promise((resolve, reject) => {
            const ajaxParams = {
                action: 'company',
                company: companyXml,
            }

            axios({
                method: "post",
                url: this.url,
                data: qs.stringify(ajaxParams,{ delimiter: '&'})
            }).then(result => {
                if (result.data.error) {
                    alert(result.data.error);
                }
                resolve(result.data);
            }).catch(error => {
                alert('Нет связи с 1С')
            });
        })
    }

    loadProducts(storeXML, priceXML)
    {
        return new Promise((resolve, reject) => {
            const ajaxParams = {
                action: 'products',
                store: storeXML,
                price: priceXML,
            }

            axios({
                method: "post",
                url: this.url,
                data: qs.stringify(ajaxParams,{ delimiter: '&'})
            }).then(result => {
                if (result.data.error) {
                    alert(result.data.error);
                }
                resolve(result.data);
            }).catch(error => {
                alert('Нет связи с 1С')
            });
        })
    }

    loadAnalog(productXML)
    {
        return new Promise((resolve, reject) => {
            const ajaxParams = {
                action: 'analogs',
                product: productXML
            }

            axios({
                method: "post",
                url: this.url,
                data: qs.stringify(ajaxParams,{ delimiter: '&'})
            }).then(result => {
                if (result.data.error) {
                    alert(result.data.error);
                }
                resolve(result.data);
            }).catch(error => {
                alert('Нет связи с 1С')
            });
        })
    }

}